/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { tagName } from '@ember-decorators/component';
import { computed } from '@ember/object';
import Component from '@ember/component';
import { SYNC_STATUSES } from 'cio/utils/ad-audiences';

@tagName('')
export default class StatusPopover extends Component {
  // internal
  @computed('type')
  get _statuses() {
    return Object.values(SYNC_STATUSES).map((status) => {
      return { ...status, message: status.explanation({ name: 'the Ad Network' }) };
    });
  }
}
